import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonCommunicationService } from 'src/app/core/services/commonCommunication.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false
})
export class LoaderComponent implements OnInit, OnDestroy {
  public isLoading: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(private ccs: CommonCommunicationService) {}

  ngOnInit(): void {
    this.ccs
      .getLoader()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.isLoading = res;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
